/**
 * Current date in the UK as "YYYY-MM-DD".
 */
export function ukToday() {
  return new Date().toLocaleDateString("en-CA", {
    timeZone: "Europe/London",
  });
}
